import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SchedulesReminderPage } from './schedules-reminder.page';

const routes: Routes = [
  {
    path: '',
    component: SchedulesReminderPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SchedulesReminderPageRoutingModule {}
